import Widget from '../Widget';
import { debounce } from 'widgets/toolbox/debounce';

function checkVisible(elm) {
    const $window = $(window);
    const windowHeight = $window.height();
    const scrollTop = $window.scrollTop();

    let elementTop = 0;
    let elementHeight = 0;
    if (elm && elm.offset() && elm.height()) {
        elementTop = elm.offset().top;
        elementHeight = elm.height();
    }

    return ((elementTop < (windowHeight + scrollTop)) && (elementTop > (scrollTop - elementHeight)));
}

function getVisibleHeight(elm) {
    const elementHeight = elm.outerHeight();
    const rect = elm[0].getBoundingClientRect();
    const top = rect.top;
    const bottom = rect.bottom;
    const windowHeight = window.innerHeight;

    return Math.max(0, top > 0 ? Math.min(elementHeight, windowHeight - top) : Math.min(bottom, windowHeight));
}

function getVisibleHeightOfOverlappedImage(imageContainer, headerOverlapOne, headerOverlapTwo, headerOverlapThree) {
    const containerRect = imageContainer.getBoundingClientRect();
    const imageHeight = containerRect.height;
    const top = containerRect.top;
    const bottom = containerRect.bottom;
    const windowHeight = window.innerHeight;
    const overlapHeight = (headerOverlapOne && checkVisible(headerOverlapOne) ? getVisibleHeight(headerOverlapOne) : 0) +
        (headerOverlapTwo && checkVisible(headerOverlapTwo) ? getVisibleHeight(headerOverlapTwo) : 0) +
        (headerOverlapThree ? headerOverlapThree.outerHeight() : 0); // overlapThree is always visible

    return {
        visibleHeight: Math.max(0, top > 0 ? Math.min(imageHeight, windowHeight - overlapHeight) : Math.min(Math.min(bottom, windowHeight) - overlapHeight, windowHeight)),
        overlapHeight: overlapHeight
    };
}

function isImageCenterAboveScroll(imageElement) {
    const imageRect = imageElement.getBoundingClientRect();
    const imageCenterY = imageRect.top + (imageRect.height / 2);
    const scrollY = window.scrollY;
    const viewportHeight = window.innerHeight;
    const scrollCenterY = scrollY + (viewportHeight / 2);

    if (imageCenterY <= scrollCenterY) {
        return true;
    }

    return false;
}

function setStickyTopPosition(imageContainer, stickyText, headerOverlapOne, headerOverlapTwo, headerOverlapThree, cta) {
    const visibleHeight = getVisibleHeightOfOverlappedImage(imageContainer, headerOverlapOne, headerOverlapTwo, headerOverlapThree);
    const isCenterAboveScroll = isImageCenterAboveScroll(imageContainer);
    const imageRect = imageContainer.getBoundingClientRect();
    let topDistance;

    if (isCenterAboveScroll) {
        topDistance = (imageRect.height - stickyText.offsetHeight) / 2 + visibleHeight.overlapHeight;

        if (cta) {
            topDistance = (imageRect.height + stickyText.offsetHeight) / 2;
        }
    } else {
        topDistance = (visibleHeight.visibleHeight - stickyText.offsetHeight) / 2 + visibleHeight.overlapHeight;
        if (window.innerWidth >= 768) {
            if (cta) {
                topDistance = visibleHeight.visibleHeight - stickyText.offsetHeight + visibleHeight.overlapHeight;
            }
        }
    }

    if (window.innerWidth < 768) {
        if (cta) {
            topDistance = visibleHeight.visibleHeight - stickyText.offsetHeight + visibleHeight.overlapHeight;
        }
    }

    if (topDistance > 0) {
        stickyText.style.top = `${topDistance}px`;
    }
}

export default class StickyCenter extends Widget {
    init() {
        let imageContainer = this.ref('self').els[0].querySelector('img');

        if (!imageContainer) {
            imageContainer = this.ref('self').els[0].querySelector('video');
        }
        const stickyText = this.ref('self').els[0].querySelector('.bleed-float-wrap');
        const absoluteWraper = this.ref('self').els[0].querySelector('.bleed-absolute-wrap');
        const nextCta = this.ref('self').els[0].querySelectorAll('.next-cta');
        const bleedCtaWrap = this.ref('self').els[0].querySelector('.bleed-cta-wrap');
        const nextText = this.ref('self').els[0].querySelector('.next-text');
        const isTransparentHeader = !!this.ref('self').els[0].closest('.next-template-d__transparent');
        const headerOverlapOne = $('#header-location-banner');
        const headerOverlapTwo = $('#header-promo');
        const headerOverlapThree = isTransparentHeader ? null : $('#global-header');

        let isCtaFloat = false;
        if (this.ref('self').els[0].hasAttribute('ctafloat')) {
            isCtaFloat =
            this.ref('self').els[0].getAttribute('ctafloat') === 'true';
        }

        if (!imageContainer || !stickyText || !absoluteWraper) {
            return;
        }

        const containerHeightRect = imageContainer.getBoundingClientRect();

        if (nextCta.length === 4 && bleedCtaWrap) {
            bleedCtaWrap.className =
              bleedCtaWrap.className + ' bleed-cta-wrap__four-cta';
        }

        // Apply the float class for CTA when needed
        if (
            nextCta.length === 1 &&
            absoluteWraper &&
            !nextText &&
            bleedCtaWrap &&
            isCtaFloat
        ) {
            bleedCtaWrap.className += ' bleed-cta-wrap__float';
            nextCta[0].className += ' bleed-cta__float';
            setStickyTopPosition(imageContainer, stickyText, headerOverlapOne, headerOverlapTwo, headerOverlapThree, nextCta[0]);
        } else {
            setStickyTopPosition(imageContainer, stickyText, headerOverlapOne, headerOverlapTwo, headerOverlapThree);

            absoluteWraper.style.paddingBottom = `${(containerHeightRect.height - stickyText.offsetHeight) / 2}px`;

            const onScroll = debounce(() => {
                setStickyTopPosition(imageContainer, stickyText, headerOverlapOne, headerOverlapTwo, headerOverlapThree);
            }, 100);

            const onResizeOrientationChange = function () {
                absoluteWraper.style.paddingBottom = `${(containerHeightRect.height - stickyText.offsetHeight) / 2}px`;
            };

            window.addEventListener('scroll', onScroll);
            window.addEventListener('resize', onScroll);
            window.addEventListener('orientationchange', onScroll);
            window.addEventListener('resize', onResizeOrientationChange);
            window.addEventListener(
                'orientationchange',
                onResizeOrientationChange
            );
        }
    }
}
